<template>
    <div>
        <div class="d-flex flex-row justify-content-center mt-3">
            <div>
                <div class="text-center font-weight-bold text-lg opacity-50">
                    Bestellung bearbeiten
                </div>
                <div class="btn-group">
                    <button v-if="isPending" class="btn btn-success font-weight-bold px-5"
                            @click="transitionTo(OrderState.Confirmed)">
                        <i class="fas fa-check"/>
                        {{ __('actions.accept') }}
                    </button>
                    <button v-if="isConfirmed || isWaitingForIntegration"
                            class="btn btn-success font-weight-bold px-5"
                            @click="transitionTo(isDelivery ? OrderState.Send : OrderState.ReadyForPickup)"
                            :disabled="isWaitingForIntegration"
                    >
                        <i v-if="!isWaitingForIntegration" class="fas fa-check"/>
                        <ButtonSpinner v-else show />
                        {{
                            isDelivery ? __('actions.order.transition_to.send') : __(
                                'actions.order.transition_to.pickup')
                        }}
                    </button>
                    <button v-if="isReadyForPickup" class="btn btn-success font-weight-bold px-5"
                            @click="transitionTo(OrderState.PickedUp)"
                            :disabled="isWaitingForIntegration"
                    >
                        <i class="fas fa-check"/>
                        {{ __('actions.order.transition_to.collected') }}
                    </button>
                    <button v-if="isPending || isWaitingForIntegration || isConfirmed"
                            class="btn btn-danger font-weight-bold px-5"
                            @click="rejectOrder">
                        <i class="fas fa-times"/>
                        {{ __('actions.reject') }}
                    </button>
                    <button v-if="order.needs_refund" class="btn btn-success font-weight-bold px-5"
                            @click="transitionTo(OrderState.Refunded)">
                        <i class="fas fa-clock"/>
                        {{ __('actions.order.transition_to.refunded') }}
                    </button>
                    <Link v-if="isFulfilled || isReadyForPickup"
                          as="button"
                          :href="$route('order.refund', [store.id, order.url_key])"
                          :only="['refundOptions']"
                          class="btn btn-danger font-weight-bold px-5">
                        <i class="fas fa-times-circle"/>
                        Stornieren / Retoure
                    </Link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';
import { Link } from '@inertiajs/vue2';
import {OrderState} from '@composables/orderStates';
import ButtonSpinner from "../ButtonSpinner.vue";

export default {
    components: {
        ButtonSpinner,
        Spinner,
        Link,
    },

    props: {
        order: Object,
        store: Object,
    },

    methods: {
        transitionTo(newState) {
            this.$inertia.patch(this.$route('order.state', [this.store.id, this.order.url_key]), {
                to_state: newState,
            });
        },

        rejectOrder() {
            Swal.fire({
                title: 'Bestellung ablehnen?',
                text: 'Erhaltene Zahlungen werden zurückerstattet.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-danger m-0',
                confirmButtonText: 'Bestellung ablehnen',
                cancelButtonText: 'Abbrechen',
            }).then(function(result) {
                if (result.value) {
                    this.transitionTo(OrderState.Rejected);
                }
            });
        },
    },

    computed: {
        OrderState() {
            return OrderState;
        },

        isDelivery() {
            return this.order.type === 'delivery';
        },

        isFulfilled() {
            return this.order.state === OrderState.PickedUp || this.order.state === OrderState.Send;
        },

        isRefunded() {
            return this.order.state === OrderState.Refunded;
        },

        isPending() {
            return this.order.state === OrderState.Pending;
        },

        isReadyForPickup() {
            return this.order.state === OrderState.ReadyForPickup;
        },

        isConfirmed() {
            return this.order.state === OrderState.Confirmed;
        },

        isWaitingForIntegration() {
            return this.order.state === OrderState.WaitForIntegration;
        },
    },
};
</script>
